<template>
  <div class="favorite">
    <ui-button
      :icon="isFavorite ? 'bookmark-solid' : 'bookmark'"
      :color="isFavorite ? 'red' : 'black'"
      iconPosition="top"
      size="s"
      text
      @click="add"
      :round="round"
    >
      <Fragment v-if="showLabel">
        Ajouter aux favoris
      </Fragment>
    </ui-button>
  </div>
</template>
<script>
import UiButton from "@/components/ui/UiButton.vue";
import UserStore from "@/store/userStore";
import fetchApi from "@/mixins/fetchApi";
import { EventBus } from "@/mixins/event-bus";
import { Fragment } from "vue-fragment";
export default {
  components: { UiButton, Fragment },
  props: {
    recipe: { type: Object },
    showLabel: { default: true },
    round: { required: false, default: false },
  },
  computed: {
    isFavorite() {
      return (
        UserStore.state.favorites &&
        UserStore.state.favorites.includes(this.recipe.id)
      );
    },
  },
  methods: {
    add() {
      if (!UserStore.state.logged) {
        EventBus.$emit("openLoginModal");
      } else {
        if (this.isFavorite) {
          this.removeFromFavorites();
        } else {
          this.addToFavorites();
        }
      }
    },
    async addToFavorites() {
      const result = await fetchApi.post("user/favorites", {
        recipe: this.recipe.id,
      });
      if (result.status !== 401) {
        UserStore.commit("addToFavorites", this.recipe.id);
      }
    },
    async removeFromFavorites() {
      const result = await fetchApi.delete("user/favorites/" + this.recipe.id);
      if (result.status !== 401) {
        UserStore.commit("removeFromFavorites", this.recipe.id);
      }
    },
  },
};
</script>
<style lang="scss">
.favorite {
  .btn__text {
    color: $black;
  }
}
</style>
